import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/investing-account")({
  loader: ({ context }) => {
    void import("~/features/investing-account/investing-account-route").then(
      ({ preloadInvestingAccountRoute }) => {
        void preloadInvestingAccountRoute(context);
      },
    );
  },
});
